import React from 'react';
import { services } from '../mock';

const Services = () => {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  return (
    <section id="hizmetler" className="section">
      <div className="section-inner">
        <div className="section-head">
          <div className="section-label">Hizmetlerimiz</div>
          <h2 className="section-title">
            Uzman Ellerde Hayat Bulan <br />
            <span className="accent">Döşeme Sanatı</span>
          </h2>
        </div>
        <div className="services-grid">
          {services.map((s) => (
            <article key={s.id} className="service-card">
              <div className="service-image">
                <img src={s.image} alt={s.title} loading="lazy" />
              </div>
              <div className="service-body">
                <h3 className="service-title">{s.title}</h3>
                <p className="service-desc">{s.description}</p>
                <div className="service-tags">
                  {s.tags.map((t) => (
                    <span key={t} className="service-tag">{t}</span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
        <div className="services-cta">
          <p>Aracınız için özel teklif almak ister misiniz?</p>
          <button className="btn-primary" onClick={() => scrollTo('iletisim')}>Ücretsiz Değerlendirme</button>
        </div>
      </div>
    </section>
  );
};

export default Services;
